import React from "react";

function CommonUseCases({
  backgroundCol,
  firstTitle,
  midTitle,
  secondTitle,
  midCol,
  para,
}) {
  return (
    <div
      className={`${
        backgroundCol ? backgroundCol : "bg-midBlue"
      }  flex items-center justify-center`}
    >
      <div className=" w-6/12 flex-col mx-auto justify-center text-white py-20 text-center">
        <h2 className="text-4xl font-bold font-secondary">
          {firstTitle ? firstTitle : ""}
          {midTitle ? (
            <span className={`${midCol ? midCol : "text-orange"} `}>
              {midTitle}
            </span>
          ) : (
            "Use"
          )}
          {secondTitle ? secondTitle : ""}
        </h2>
        <p className="font-opensans text-darkMist mt-10">
          {para
            ? para
            : "There are many common use cases for our technical translations done by our technical translators, including:"}
        </p>
        <div className="bottom flex flex-col lg:flex-row mx-auto justify-between  text-left pt-16 font-light">
          <ul className="list-disc">
            <li className="pb-6">Engineering Texts</li>
            <li className="pb-6">User Manuals</li>
            <li className="pb-6">Scientific Procedures</li>
            <li className="pb-6">Research Papers</li>
          </ul>
          <ul className="list-disc">
            <li className="pb-6">Research Data</li>
            <li className="pb-6">Technical Contracts</li>
            <li className="pb-6">Patents</li>
            <li className="pb-6">Product Specifications and Descriptions</li>
          </ul>
          <ul className="list-disc">
            <li className="pb-6">Technical Contracts</li>
            <li className="pb-6">Assembly Manuals</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default CommonUseCases;
